// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useEffect, useState, useContext } from 'react';
import cn from 'classnames';
import etask from '/util/etask.js';
import _ from 'zutil';
import '/www/hola/pub/css/core/input.less';
import { Svg } from '../shared/svg';
import { Settings_context } from '../settings_ctx';
export var Input = props => {
  var _useContext = useContext(Settings_context),
    theme = _useContext.theme,
    theme_name = _useContext.theme_name;
  var cl = props.cl,
    round = props.round,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    name = props.name,
    auto_complete = props.auto_complete,
    on_change = props.on_change,
    tab_index = props.tab_index,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? ' ' : _props$placeholder,
    value = props.value,
    validator = props.validator,
    label = props.label,
    on_validation = props.on_validation,
    error = props.error,
    auto_focus = props.auto_focus,
    select_by_focus = props.select_by_focus,
    center = props.center,
    error_style = props.error_style,
    no_margin = props.no_margin,
    on_blur = props.on_blur,
    color = props.color,
    size = props.size,
    icon = props.icon,
    Icon = props.Icon,
    icon_size = props.icon_size,
    input_cls = props.input_cls,
    left_align_icon = props.left_align_icon,
    on_focus = props.on_focus,
    no_caret = props.no_caret,
    area_label = props.area_label,
    on_click = props.on_click,
    inputmode = props.inputmode,
    on_icon_click = props.on_icon_click,
    disabled = props.disabled,
    read_only = props.read_only;
  var is_hola2023 = theme_name == 'hola2023';
  var ref = useRef();
  var on_blur_ = () => etask(function* () {
    var validation_error = validator ? yield validator(value) : '';
    set_err(validation_error);
    if (on_validation) on_validation(validation_error);
    if (on_blur) on_blur();
  });
  var on_focus_hdl = ev => {
    if (on_focus) on_focus();
    if (select_by_focus) ev.target.setSelectionRange(0, value && value.length || 255);
  };
  var _useState = useState(error),
    _useState2 = _slicedToArray(_useState, 2),
    err = _useState2[0],
    set_err = _useState2[1];
  useEffect(() => {
    if (err != error) set_err(error);
  }, [error]);
  useEffect(() => {
    if (auto_focus && ref && ref.current) {
      setTimeout(() => {
        if (!ref.current) return;
        ref.current.focus();
        ref.current.select();
      }, 30);
    }
  }, [auto_focus]);
  var cls = cn(input_cls, 'hola_input', round && 'hola_input--round', (err || error_style) && 'hola_input--error', center && 'hola_input--center', color && `hola_input--${color}`, size && `hola_input--${size}`, (icon || Icon) && (left_align_icon ? `hola_input--has_icon_left` : `hola_input--has_icon`), icon_size && `hola_input_icon--${icon_size}`, no_caret && 'hola_input--pointer');
  var container_cls = cn(cl, 'form_field hola_input_container', is_hola2023 && 'hola_input_container--hola2023', no_margin && 'hola_input_container--no_margin', (err || error_style) && 'hola_input--with_error', no_caret && 'hola_input--no_caret_input', !!on_click && 'hola_input--pointer_for_container');
  var input_field = /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    className: cls,
    ref: ref,
    autoComplete: auto_complete,
    onBlur: on_blur_,
    placeholder: placeholder,
    value: value || '',
    tabIndex: tab_index,
    name: name,
    readOnly: read_only,
    onFocus: on_focus_hdl,
    disabled: no_caret || disabled,
    "area-label": area_label,
    inputMode: inputmode,
    onChange: ev => etask(function* () {
      var v = ev.target.value;
      on_change(v, ev);
      if (props.on_change_validation === false) {
        if (validator) set_err('');
        return;
      }
      var validation_error = validator ? yield validator(v) : '';
      set_err(validation_error);
      if (on_validation) on_validation(validation_error);
    })
  }, _.pick(props, 'onKeyDown', 'onKeyPress', 'onInput')));
  var icon_cls = cn('hola_input_icon', left_align_icon && 'hola_input_icon--left', icon_size && `hola_input_icon--${icon_size}`, on_icon_click && `hola_input_icon--pointer`);
  return /*#__PURE__*/React.createElement("div", {
    className: container_cls,
    onClick: on_click
  }, label && (typeof label == 'string' ? /*#__PURE__*/React.createElement("span", {
    className: cn('lbl', is_hola2023 && cn(theme.P, theme.p5, theme.med))
  }, label) : label), /*#__PURE__*/React.createElement("div", {
    className: "hola_input_block"
  }, input_field, icon && /*#__PURE__*/React.createElement(Svg, {
    icon: icon,
    cls: icon_cls,
    on_click: on_icon_click
  }), !icon && Icon && /*#__PURE__*/React.createElement(Icon, {
    className: icon_cls
  })), err && /*#__PURE__*/React.createElement("span", {
    className: cn(is_hola2023 ? 'err_msg--hola2023' : 'err_msg')
  }, err));
};